import React from "react";
import { Link } from 'react-router-dom'
function Social() {
        return(
            <div className="container">
            <br/><br/><br/><br/>
            <h2>Instagram</h2>
            <img src="assets/imgs/instagram.png" alt="Instagram" width="90%" height="600px" style={{ margin: '20px 0' }} />
            <br/><br/><br/><br/>
            <hr/><hr/>
            <h2>Twitter</h2>
            <img src="assets/imgs/twitter.png" alt="Twitter" width="90%" height="600px" style={{ margin: '20px 0' }} />
            <br/><br/><br/><br/>
            <hr/><hr/>
            <h2>Facebook</h2>
            <img src="assets/imgs/facebook.png" alt="Facebook" width="90%" height="600px" style={{ margin: '20px 0' }} />
            <br/><br/><br/><br/>
            <hr/><hr/>
            <h2>LinkedIn </h2>
            <img src="assets/imgs/link.png" alt="Link" width="90%" height="600px" style={{ margin: '20px 0' }} />
          </div>
          
        )
}
export default Social